/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 parking.glb -k 
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function Parking(props) {
  const { nodes, materials } = useGLTF('/parking.glb')
  return (
    <group {...props} position={[15,0,3]} rotation={[0, Math.PI + Math.PI / 20 , 0]} dispose={null}>
      <mesh name="Plane" geometry={nodes.Plane.geometry} material={materials['Cement.003']} position={[39.261, 2.442, -3.176]} rotation={[Math.PI / 2, 0, -0.237]} scale={-1.649} />
      <mesh name="Plane024" geometry={nodes.Plane024.geometry} material={materials['Cement.003']} position={[55.405, 2.442, 7.521]} rotation={[Math.PI / 2, 0, -0.479]} scale={-1.649} />
      <mesh name="_x32_" geometry={nodes._x32_.geometry} material={nodes._x32_.material} position={[12.112, -0.099, 0.667]} rotation={[0, 0.125, 0]} />
      <mesh name="_x32_001" geometry={nodes._x32_001.geometry} material={nodes._x32_001.material} position={[40.007, 1.206, 8.002]} rotation={[0, 0.43, 0]} />
      <mesh name="_x32_002" geometry={nodes._x32_002.geometry} material={nodes._x32_002.material} position={[28.931, 1.209, 6.845]} rotation={[0, 0.262, 0]} />
      <mesh name="_x32_003" geometry={nodes._x32_003.geometry} material={nodes._x32_003.material} position={[15.096, 1.205, 3.162]} rotation={[0, 0.262, 0]} />
      <group name="Circle002" position={[42.096, 1.213, -76.006]} scale={77.137}>
        <mesh name="Circle002_1" geometry={nodes.Circle002_1.geometry} material={materials['Cement.002']} />
        <mesh name="Circle002_2" geometry={nodes.Circle002_2.geometry} material={materials['Material.001']} />
      </group>
    </group>
  )
}

useGLTF.preload('/parking.glb')